import { useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/**
 * Reusable confirm dialog. Wrap an action button:
 *
 *   <ConfirmDialog
 *     title="Slett tjenesten?"
 *     description="Denne handlingen kan ikke angres."
 *     confirmLabel="Slett"
 *     onConfirm={() => doDelete(id)}
 *     trigger={(open) => <Button onClick={open}>Slett</Button>}
 *     destructive
 *   />
 */
export default function ConfirmDialog({
  title, description, confirmLabel = "Bekreft", cancelLabel = "Avbryt",
  onConfirm, destructive = false, trigger, testId = "confirm-dialog",
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      {trigger(() => setOpen(true))}
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="rounded-2xl" data-testid={testId}>
          <AlertDialogHeader>
            <AlertDialogTitle className="font-heading">{title}</AlertDialogTitle>
            {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="rounded-xl" data-testid={`${testId}-cancel`}>{cancelLabel}</AlertDialogCancel>
            <AlertDialogAction
              onClick={onConfirm}
              className={`rounded-xl ${destructive ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : ""}`}
              data-testid={`${testId}-confirm`}
            >
              {confirmLabel}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
